import React, { Fragment } from 'react';
import { common } from '@kurtosys/ksys-app-template';
import { observer } from 'mobx-react';

import { InjectedStyledComponent } from '../../../../../shared/index.js';
import Translate from '../../../Translate/Translate.js';
import { TableComponentBase } from '../TableComponentBase.js';

import { ICellValueConfiguration, ICellValueProps, ICellValueState } from './models/index.js';
import {
	CELL_VALUE_CATEGORY_KEY,
	CELL_VALUE_COMPONENT_KEY,
	CELL_VALUE_PARENT_COMPONENT_KEY,
} from './CellValue.meta.js';

export class CellValue extends TableComponentBase<ICellValueProps, ICellValueState, ICellValueConfiguration> {
	categoryKey = CELL_VALUE_CATEGORY_KEY;
	componentKey = CELL_VALUE_COMPONENT_KEY;
	get parentComponentKey(): string | undefined {
		return CELL_VALUE_PARENT_COMPONENT_KEY;
	}

	get tableEventsKey() {
		return undefined;
	}

	constructor(props: ICellValueProps) {
		super(props);
	}

	render() {
		const { column, cellValue } = this.props;
		const { arraySeparator } = column;
		if (!common.commonUtils.isUndefined(arraySeparator) && common.commonUtils.isArrayLike(cellValue)) {
			return (
				<Fragment>
					{cellValue.map((subValue, subIndex) => {
						return (
							<Fragment key={`${subIndex}_${subValue}`}>
								{subIndex > 0 && <span>{arraySeparator}</span>}
								<Translate>{subValue}</Translate>
							</Fragment>
						);
					})}
				</Fragment>
			);
		}
		return <Translate>{cellValue}</Translate>;
	}
}

export default InjectedStyledComponent(observer(CellValue), CELL_VALUE_CATEGORY_KEY, CELL_VALUE_PARENT_COMPONENT_KEY, [
	CELL_VALUE_COMPONENT_KEY,
]);
